[
  {
    "id": "DH-000018",
    "slug": "abelle",
    "name": "Abelle",
    "language": "French",
    "defaultLocale": "fr-FR",
    "voice": "coral",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/abelle/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/abelle/variants/360x480/poster.jpg",
    "group": "French"
  },
  {
    "id": "DH-000023",
    "slug": "adele",
    "name": "Adele",
    "language": "Italian",
    "defaultLocale": "it-IT",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/adele/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/adele/variants/360x480/poster.jpg",
    "group": "Italian"
  },
  {
    "id": "DH-000067",
    "slug": "adelia",
    "name": "Adelia",
    "language": "Indonesian",
    "defaultLocale": "id-ID",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/adelia/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/adelia/variants/360x480/poster.jpg",
    "group": "Indonesian"
  },
  {
    "id": "DH-000069",
    "slug": "adira",
    "name": "Adira",
    "language": "Indonesian",
    "defaultLocale": "id-ID",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/adira/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/adira/variants/360x480/poster.jpg",
    "group": "Indonesian"
  },
  {
    "id": "DH-000068",
    "slug": "agung",
    "name": "Agung",
    "language": "Indonesian",
    "defaultLocale": "id-ID",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/agung/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/agung/variants/360x480/poster.jpg",
    "group": "Indonesian"
  },
  {
    "id": "DH-000049",
    "slug": "ai",
    "name": "Ai",
    "language": "Mandarin",
    "defaultLocale": "zh-CN",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/ai/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/ai/variants/360x480/poster.jpg",
    "group": "Chinese"
  },
  {
    "id": "DH-000055",
    "slug": "aiJapanese",
    "name": "Ai",
    "language": "Japanese",
    "defaultLocale": "ja-JP",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/aiJapanese/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/aiJapanese/variants/360x480/poster.jpg",
    "group": "Japanese"
  },
  {
    "id": "DH-000056",
    "slug": "aoto",
    "name": "Aoto",
    "language": "Japanese",
    "defaultLocale": "ja-JP",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/aoto/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/aoto/variants/360x480/poster.jpg",
    "group": "Japanese"
  },
  {
    "id": "DH-000044",
    "slug": "ashwin",
    "name": "Ashwin",
    "language": "Hindi",
    "defaultLocale": "hi-IN",
    "voice": "echo",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/ashwin/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/ashwin/variants/360x480/poster.jpg",
    "group": "Hindi"
  },
  {
    "id": "DH-000057",
    "slug": "azami",
    "name": "Azami",
    "language": "Japanese",
    "defaultLocale": "ja-JP",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/azami/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/02/humans/azami/variants/360x480/poster.jpg",
    "group": "Japanese"
  },
  {
    "id": "DH-000009",
    "slug": "ben",
    "name": "Ben",
    "language": "English",
    "defaultLocale": "en-US",
    "voice": "echo",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/ben/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/ben/variants/360x480/poster.jpg",
    "group": "English"
  },
  {
    "id": "DH-000050",
    "slug": "bo",
    "name": "Bo",
    "language": "Mandarin",
    "defaultLocale": "zh-CN",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/bo/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/bo/variants/360x480/poster.jpg",
    "group": "Chinese"
  },
  {
    "id": "DH-000042",
    "slug": "boris",
    "name": "Boris",
    "language": "Russian",
    "defaultLocale": "ru-RU",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/boris/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/boris/variants/360x480/poster.jpg",
    "group": "Russian"
  },
  {
    "id": "initial-bud",
    "slug": "bud",
    "name": "Bud",
    "language": "English",
    "defaultLocale": "en-US",
    "voice": "ash",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/01/humans/bud/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/01/humans/bud/variants/360x480/poster.jpg",
    "group": "English"
  },
  {
    "id": "DH-000035",
    "slug": "cecilia",
    "name": "Cecilia",
    "language": "Portuguese",
    "defaultLocale": "pt-BR",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/cecilia/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/cecilia/variants/360x480/poster.jpg",
    "group": "Portuguese"
  },
  {
    "id": "DH-000061",
    "slug": "chon",
    "name": "Chon",
    "language": "Korean",
    "defaultLocale": "ko-KR",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/chon/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/chon/variants/360x480/poster.jpg",
    "group": "Korean"
  },
  {
    "id": "DH-000070",
    "slug": "cipto",
    "name": "Cipto",
    "language": "Indonesian",
    "defaultLocale": "id-ID",
    "voice": "ash",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/cipto/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/cipto/variants/360x480/poster.jpg",
    "group": "Indonesian"
  },
  {
    "id": "initial-cloe",
    "slug": "cloe",
    "name": "Cloe",
    "language": "French",
    "defaultLocale": "fr-FR",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/cloe/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/cloe/variants/360x480/poster.jpg",
    "group": "French"
  },
  {
    "id": "DH-000071",
    "slug": "dahlia",
    "name": "Dahlia",
    "language": "Indonesian",
    "defaultLocale": "id-ID",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/dahlia/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/dahlia/variants/360x480/poster.jpg",
    "group": "Indonesian"
  },
  {
    "id": "DH-000039",
    "slug": "daria",
    "name": "Daria",
    "language": "Russian",
    "defaultLocale": "ru-RU",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/daria/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/daria/variants/360x480/poster.jpg",
    "group": "Russian"
  },
  {
    "id": "DH-000040",
    "slug": "denia",
    "name": "Denia",
    "language": "Russian",
    "defaultLocale": "ru-RU",
    "voice": "echo",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/denia/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/03/humans/denia/variants/360x480/poster.jpg",
    "group": "Russian"
  },
  {
    "id": "DH-000073",
    "slug": "dung",
    "name": "Dung",
    "language": "Vietnamese",
    "defaultLocale": "vi-VN",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/dung/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/dung/variants/360x480/poster.jpg",
    "group": "Vietnamese"
  },
  {
    "id": "DH-000019",
    "slug": "eliott",
    "name": "Eliott",
    "language": "French",
    "defaultLocale": "fr-FR",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/eliott/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/eliott/variants/360x480/poster.jpg",
    "group": "French"
  },
  {
    "id": "initial-elsa",
    "slug": "elsa",
    "name": "Elsa",
    "language": "German",
    "defaultLocale": "de-DE",
    "voice": "coral",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/elsa/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/elsa/variants/360x480/poster.jpg",
    "group": "German"
  },
  {
    "id": "DH-000059",
    "slug": "emiko",
    "name": "Emiko",
    "language": "Japanese",
    "defaultLocale": "ja-JP",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/emiko/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/emiko/variants/360x480/poster.jpg",
    "group": "Japanese"
  },
  {
    "id": "DH-000014",
    "slug": "emilia",
    "name": "Emilia",
    "language": "German",
    "defaultLocale": "de-DE",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260906-emilia-v4/humans/emilia/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260906-emilia-v4/humans/emilia/variants/360x480/poster.jpg",
    "group": "German"
  },
  {
    "id": "DH-000007",
    "slug": "emma",
    "name": "Emma",
    "language": "English",
    "defaultLocale": "en-US",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/01/humans/emma/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/01/humans/emma/variants/360x480/poster.jpg",
    "group": "English"
  },
  {
    "id": "DH-000072",
    "slug": "fajar",
    "name": "Fajar",
    "language": "Indonesian",
    "defaultLocale": "id-ID",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/fajar/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/fajar/variants/360x480/poster.jpg",
    "group": "Indonesian"
  },
  {
    "id": "DH-000015",
    "slug": "felix",
    "name": "Felix",
    "language": "German",
    "defaultLocale": "de-DE",
    "voice": "ash",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/felix/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/felix/variants/360x480/poster.jpg",
    "group": "German"
  },
  {
    "id": "DH-000029",
    "slug": "francisco",
    "name": "Francisco",
    "language": "Spanish",
    "defaultLocale": "es-ES",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/francisco/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/francisco/variants/360x480/poster.jpg",
    "group": "Spanish"
  },
  {
    "id": "DH-000054",
    "slug": "fu",
    "name": "Fu",
    "language": "Mandarin",
    "defaultLocale": "zh-CN",
    "voice": "ash",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/fu/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/fu/variants/360x480/poster.jpg",
    "group": "Chinese"
  },
  {
    "id": "DH-000008",
    "slug": "george",
    "name": "George",
    "language": "English",
    "defaultLocale": "en-US",
    "voice": "echo",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/george/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/04/humans/george/variants/360x480/poster.jpg",
    "group": "English"
  },
  {
    "id": "DH-000075",
    "slug": "hang",
    "name": "Hang",
    "language": "Vietnamese",
    "defaultLocale": "vi-VN",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/hang/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/hang/variants/360x480/poster.jpg",
    "group": "Vietnamese"
  },
  {
    "id": "DH-000058",
    "slug": "hanzo",
    "name": "Hanzo",
    "language": "Japanese",
    "defaultLocale": "ja-JP",
    "voice": "ash",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/hanzo/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/hanzo/variants/360x480/poster.jpg",
    "group": "Japanese"
  },
  {
    "id": "DH-000034",
    "slug": "heitor",
    "name": "Heitor",
    "language": "Portuguese",
    "defaultLocale": "pt-BR",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/heitor/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/heitor/variants/360x480/poster.jpg",
    "group": "Portuguese"
  },
  {
    "id": "DH-000031",
    "slug": "helena",
    "name": "Helena",
    "language": "Portuguese",
    "defaultLocale": "pt-BR",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/helena/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/helena/variants/360x480/poster.jpg",
    "group": "Portuguese"
  },
  {
    "id": "DH-000060",
    "slug": "hiro",
    "name": "Hiro",
    "language": "Japanese",
    "defaultLocale": "ja-JP",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/hiro/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/hiro/variants/360x480/poster.jpg",
    "group": "Japanese"
  },
  {
    "id": "DH-000077",
    "slug": "hoa",
    "name": "Hoa",
    "language": "Vietnamese",
    "defaultLocale": "vi-VN",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/hoa/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/hoa/variants/360x480/poster.jpg",
    "group": "Vietnamese"
  },
  {
    "id": "DH-000053",
    "slug": "hua",
    "name": "Hua",
    "language": "Mandarin",
    "defaultLocale": "zh-CN",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/hua/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/hua/variants/360x480/poster.jpg",
    "group": "Chinese"
  },
  {
    "id": "DH-000041",
    "slug": "irina",
    "name": "Irina",
    "language": "Russian",
    "defaultLocale": "ru-RU",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/irina/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/irina/variants/360x480/poster.jpg",
    "group": "Russian"
  },
  {
    "id": "DH-000022",
    "slug": "isabel",
    "name": "Isabel",
    "language": "Italian",
    "defaultLocale": "it-IT",
    "voice": "sage",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/isabel/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/isabel/variants/360x480/poster.jpg",
    "group": "Italian"
  },
  {
    "id": "DH-000027",
    "slug": "isabelSpanish",
    "name": "Isabel",
    "language": "Spanish",
    "defaultLocale": "es-ES",
    "voice": "coral",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/isabelSpanish/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/05/humans/isabelSpanish/variants/360x480/poster.jpg",
    "group": "Spanish"
  },
  {
    "id": "DH-000038",
    "slug": "ivan",
    "name": "Ivan",
    "language": "Russian",
    "defaultLocale": "ru-RU",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/ivan/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/ivan/variants/360x480/poster.jpg",
    "group": "Russian"
  },
  {
    "id": "DH-000063",
    "slug": "jiji",
    "name": "Jiji",
    "language": "Korean",
    "defaultLocale": "ko-KR",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/jiji/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/jiji/variants/360x480/poster.jpg",
    "group": "Korean"
  },
  {
    "id": "DH-000030",
    "slug": "jorge",
    "name": "Jorge",
    "language": "Spanish",
    "defaultLocale": "es-ES",
    "voice": "ash",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/jorge/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/jorge/variants/360x480/poster.jpg",
    "group": "Spanish"
  },
  {
    "id": "DH-000046",
    "slug": "kamal",
    "name": "Kamal",
    "language": "Hindi",
    "defaultLocale": "hi-IN",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/kamal/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/kamal/variants/360x480/poster.jpg",
    "group": "Hindi"
  },
  {
    "id": "DH-000043",
    "slug": "laya",
    "name": "Laya",
    "language": "Hindi",
    "defaultLocale": "hi-IN",
    "voice": "sage",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/laya/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/laya/variants/360x480/poster.jpg",
    "group": "Hindi"
  },
  {
    "id": "DH-000051",
    "slug": "li",
    "name": "Li",
    "language": "Mandarin",
    "defaultLocale": "zh-CN",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/li/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/li/variants/360x480/poster.jpg",
    "group": "Chinese"
  },
  {
    "id": "initial-lucia",
    "slug": "lucia",
    "name": "Lucia",
    "language": "Spanish",
    "defaultLocale": "es-ES",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/01/humans/lucia/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/01/humans/lucia/variants/360x480/poster.jpg",
    "group": "Spanish"
  },
  {
    "id": "initial-lukas",
    "slug": "lukas",
    "name": "Lukas",
    "language": "German",
    "defaultLocale": "de-DE",
    "voice": "verse",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/01/humans/lukas/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/01/humans/lukas/variants/360x480/poster.jpg",
    "group": "German"
  },
  {
    "id": "initial-marco",
    "slug": "marco",
    "name": "Marco",
    "language": "Italian",
    "defaultLocale": "it-IT",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/marco/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/marco/variants/360x480/poster.jpg",
    "group": "Italian"
  },
  {
    "id": "DH-000033",
    "slug": "maria",
    "name": "Maria",
    "language": "Portuguese",
    "defaultLocale": "pt-BR",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/maria/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/maria/variants/360x480/poster.jpg",
    "group": "Portuguese"
  },
  {
    "id": "DH-000037",
    "slug": "mariaRussian",
    "name": "Maria",
    "language": "Russian",
    "defaultLocale": "ru-RU",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/mariaRussian/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/mariaRussian/variants/360x480/poster.jpg",
    "group": "Russian"
  },
  {
    "id": "DH-000026",
    "slug": "marina",
    "name": "Marina",
    "language": "Spanish",
    "defaultLocale": "es-ES",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/marina/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/06/humans/marina/variants/360x480/poster.jpg",
    "group": "Spanish"
  },
  {
    "id": "DH-000024",
    "slug": "matteo",
    "name": "Matteo",
    "language": "Italian",
    "defaultLocale": "it-IT",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/matteo/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/matteo/variants/360x480/poster.jpg",
    "group": "Italian"
  },
  {
    "id": "DH-000032",
    "slug": "miguel",
    "name": "Miguel",
    "language": "Portuguese",
    "defaultLocale": "pt-BR",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/miguel/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/miguel/variants/360x480/poster.jpg",
    "group": "Portuguese"
  },
  {
    "id": "DH-000052",
    "slug": "ming",
    "name": "Ming",
    "language": "Mandarin",
    "defaultLocale": "zh-CN",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/ming/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/ming/variants/360x480/poster.jpg",
    "group": "Chinese"
  },
  {
    "id": "DH-000010",
    "slug": "monica",
    "name": "Monica",
    "language": "English",
    "defaultLocale": "en-US",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/01/humans/monica/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/01/humans/monica/variants/360x480/poster.jpg",
    "group": "English"
  },
  {
    "id": "DH-000062",
    "slug": "moon",
    "name": "Moon",
    "language": "Korean",
    "defaultLocale": "ko-KR",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/moon/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/moon/variants/360x480/poster.jpg",
    "group": "Korean"
  },
  {
    "id": "DH-000064",
    "slug": "nari",
    "name": "Nari",
    "language": "Korean",
    "defaultLocale": "ko-KR",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/nari/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/nari/variants/360x480/poster.jpg",
    "group": "Korean"
  },
  {
    "id": "DH-000078",
    "slug": "ngan",
    "name": "Ngan",
    "language": "Vietnamese",
    "defaultLocale": "vi-VN",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/ngan/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/ngan/variants/360x480/poster.jpg",
    "group": "Vietnamese"
  },
  {
    "id": "DH-000021",
    "slug": "nicole",
    "name": "Nicole",
    "language": "Italian",
    "defaultLocale": "it-IT",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/nicole/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/nicole/variants/360x480/poster.jpg",
    "group": "Italian"
  },
  {
    "id": "DH-000011",
    "slug": "noah",
    "name": "Noah",
    "language": "English",
    "defaultLocale": "en-US",
    "voice": "ash",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/noah/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/noah/variants/360x480/poster.jpg",
    "group": "English"
  },
  {
    "id": "DH-000013",
    "slug": "paul",
    "name": "Paul",
    "language": "German",
    "defaultLocale": "de-DE",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/paul/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/paul/variants/360x480/poster.jpg",
    "group": "German"
  },
  {
    "id": "DH-000028",
    "slug": "pedro",
    "name": "Pedro",
    "language": "Spanish",
    "defaultLocale": "es-ES",
    "voice": "alloy",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/pedro/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/07/humans/pedro/variants/360x480/poster.jpg",
    "group": "Spanish"
  },
  {
    "id": "DH-000025",
    "slug": "pietro",
    "name": "Pietro",
    "language": "Italian",
    "defaultLocale": "it-IT",
    "voice": "ash",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/pietro/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/pietro/variants/360x480/poster.jpg",
    "group": "Italian"
  },
  {
    "id": "DH-000047",
    "slug": "prisha",
    "name": "Prisha",
    "language": "Hindi",
    "defaultLocale": "hi-IN",
    "voice": "coral",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/prisha/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/prisha/variants/360x480/poster.jpg",
    "group": "Hindi"
  },
  {
    "id": "DH-000076",
    "slug": "quy",
    "name": "Quy",
    "language": "Vietnamese",
    "defaultLocale": "vi-VN",
    "voice": "ash",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/quy/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/quy/variants/360x480/poster.jpg",
    "group": "Vietnamese"
  },
  {
    "id": "DH-000048",
    "slug": "rakesh",
    "name": "Rakesh",
    "language": "Hindi",
    "defaultLocale": "hi-IN",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/rakesh/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/rakesh/variants/360x480/poster.jpg",
    "group": "Hindi"
  },
  {
    "id": "DH-000065",
    "slug": "seung",
    "name": "Seung",
    "language": "Korean",
    "defaultLocale": "ko-KR",
    "voice": "ash",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/seung/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/seung/variants/360x480/poster.jpg",
    "group": "Korean"
  },
  {
    "id": "DH-000012",
    "slug": "sophia",
    "name": "Sophia",
    "language": "German",
    "defaultLocale": "de-DE",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/sophia/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/sophia/variants/360x480/poster.jpg",
    "group": "German"
  },
  {
    "id": "DH-000074",
    "slug": "thao",
    "name": "Thao",
    "language": "Vietnamese",
    "defaultLocale": "vi-VN",
    "voice": "shimmer",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/thao/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/thao/variants/360x480/poster.jpg",
    "group": "Vietnamese"
  },
  {
    "id": "DH-000017",
    "slug": "theo",
    "name": "Theo",
    "language": "French",
    "defaultLocale": "fr-FR",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/theo/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/theo/variants/360x480/poster.jpg",
    "group": "French"
  },
  {
    "id": "DH-000036",
    "slug": "theoPortuguese",
    "name": "Theo",
    "language": "Portuguese",
    "defaultLocale": "pt-BR",
    "voice": "alloy",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/theoPortuguese/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/theoPortuguese/variants/360x480/poster.jpg",
    "group": "Portuguese"
  },
  {
    "id": "DH-000020",
    "slug": "valentin",
    "name": "Valentin",
    "language": "French",
    "defaultLocale": "fr-FR",
    "voice": "alloy",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/valentin/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/08/humans/valentin/variants/360x480/poster.jpg",
    "group": "French"
  },
  {
    "id": "DH-000045",
    "slug": "yavi",
    "name": "Yavi",
    "language": "Hindi",
    "defaultLocale": "hi-IN",
    "voice": "marin",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/09/humans/yavi/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/09/humans/yavi/variants/360x480/poster.jpg",
    "group": "Hindi"
  },
  {
    "id": "DH-000066",
    "slug": "yong",
    "name": "Yong",
    "language": "Korean",
    "defaultLocale": "ko-KR",
    "voice": "cedar",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/09/humans/yong/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/09/humans/yong/variants/360x480/poster.jpg",
    "group": "Korean"
  },
  {
    "id": "DH-000016",
    "slug": "zoe",
    "name": "Zoe",
    "language": "French",
    "defaultLocale": "fr-FR",
    "voice": "sage",
    "manifestUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/09/humans/zoe/asset-manifest.json",
    "posterUrl": "https://d32q4q90fh3ret.cloudfront.net/digital-humans/sdk/v1/web/releases/web-78-20260904-v1/batches/09/humans/zoe/variants/360x480/poster.jpg",
    "group": "French"
  }
]
